import { Directive, OnDestroy } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Subject } from "rxjs";

export const defaultNumericPlaceholder = "0.00";

@Directive()
export class InputDirective implements OnDestroy {
  formControl: FormControl;
  isFocused: boolean = false;
  protected destroy$ = new Subject<void>();

  onFocus(): void {
    this.isFocused = true;
  }

  onBlur(): void {
    this.isFocused = false;
  }

  onWrapperClick(inputElement: HTMLInputElement | HTMLTextAreaElement): void {
    // Focus the input to make the entire wrapper area clickable
    inputElement.focus();
  }

  onWrapperMouseDown(
    event: MouseEvent,
    inputElement: HTMLInputElement | HTMLTextAreaElement,
  ): void {
    // If clicking on the wrapper (not the input itself), prevent default
    // This prevents the input from blurring when mousedown happens on padding
    if (event.target !== inputElement) {
      event.preventDefault();
    }
  }

  setDefaultNumberPlaceholder(type: string, placeholder: string): string {
    return type === "number" && !placeholder ? defaultNumericPlaceholder : placeholder;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
